import styled from "styled-components/native";
import { Image } from "expo-image";

import { Text3 } from "~/components/text";
import { HeaderTitle } from "~/components/header-title";
import { spacers, colors } from "~/styles/theme";

export const Title = styled(HeaderTitle)`
  text-align: center;
`;

export const Description = styled(Text3)`
  font-family: Montserrat-Regular;
  color: ${colors.gray600};
  margin-top: ${spacers.ss4};
  text-align: center;
`;

export const LogoHeader = styled(Image)`
  margin-bottom: ${spacers.ss4};
  width: 100%;
  height: 78px;
`;

export const Subtitle = styled(Text3)`
  color: ${colors.gray600};
  margin-top: ${spacers.ss4};
  text-align: center;
`;
